import React, {useEffect, useState} from 'react';
import {AutoComplete, Col, Form, message, Row} from 'antd';
import usePlacesAutocomplete, {getDetails} from "use-places-autocomplete";
import {getTotalLocationRequest} from "../../../../../api/hrm/timekeeping/time-sheet/location";
import {API_KEY_MAP_GG, PLACE_API, STATUS_CODE, TOTAL_LIMIT} from "../constant/key";
import {t} from "i18next";

const GeocoderComponent = (props) => {
    const {
        value,ready,
        suggestions: {status, data,loading}, setValue,
    } = usePlacesAutocomplete({callbackName: "initMap" , debounce : 500});
    const [hasInteracted, setHasInteracted] = useState(false);
    const [totalLimit, setTotalLimit] = useState(0);

    useEffect(() => {
        if (loading) {
                getTotalLocationRequest(PLACE_API, API_KEY_MAP_GG).then(res => {
                    setTotalLimit(res)
                })
        }

    }, [loading]);

    const handleOnSearch = (searchText) => {
      if(totalLimit < TOTAL_LIMIT){
          setValue(searchText);
          setHasInteracted(true);
      }
      else {
          message.error(t("tnp.setting.searchLimit"))
      }

    };

    const renderSuggestions = () => {
        if (data && Array.isArray(data) && status === "OK") {
            const suggestions = []
            data.forEach(({place_id, description}) => {
                    suggestions.push({value: place_id, label: description})
                }
            );
            return suggestions;
        }
        return [];
    }

    const handleOnSelect = async (value, option) => {
        try {
            props.form.setFieldValue(props.name, option.label)
            const details = await getDetails({placeId: value});
            if (details) {
                const coordinates = [details?.geometry.location?.lat(), details?.geometry.location?.lng()]
                props.setCoordinates(coordinates);
                props.setIsLoadingMap(true)
                props.form.setFieldValue(props.name, option.label)
            }
        }
        catch (e) {
          if(e === STATUS_CODE.OVER_QUERY_LIMIT) {
              props.form.setFieldValue(props.name, option.label)
              message.error(t("tnp.setting.errorSearch"))
          }
        }

    };
    function NotFoundContent(props) {

        return (
            <div className={"text-center text-black py-[30px] px-[40px]"}>
                <p className={"mb-2 font-[600] leading-[24px]"}>{t("tnp.components.objectAssign.notFound")}</p>
                <p className={"text-[14px] font-[400] leading-[20px]"}>{t("tnp.components.objectAssign.tryAgain")}</p>
            </div>
        );
    }

    return (
        <Row gutter={12}>
            <Col xxl={{span: 16}} xl={{span: 16}} lg={{span: 16}}>
                <Form.Item label={<b>{props.label}</b>} name={props.name}>
                    <AutoComplete
                        placeholder={t("tnp.setting.searchAddressPlaceholder")}
                        options={status === "OK" && renderSuggestions()}
                        onSelect={handleOnSelect}
                        onSearch={handleOnSearch}

                        notFoundContent={
                           ( status !== "OK" && data === [] && hasInteracted && value !== "" && ready )&& NotFoundContent()
                        }
                    />

                </Form.Item>
            </Col>
        </Row>
    );
};

export default GeocoderComponent;